import React, { useEffect, useState } from 'react';
import './Cummingsoon.scss';

const Cummingsoon = () => {
    const [trains, setTrains] = useState([]);

    useEffect(() => {
        // Create a new train of particles with snake-like path
        const createTrain = () => {
            const side = Math.random() < 0.5 ? 'left' : 'right';
            const isFromTop = Math.random() < 0.3; // 30% chance to come from top

            // Determine starting position
            const startX = isFromTop ? Math.random() * 100 : (side === 'left' ? -5 : 105);
            const startY = isFromTop ? -5 : Math.random() * 30;

            // Determine initial trajectory with more randomness
            const baseSpeedX = isFromTop ? (Math.random() - 0.5) * 0.8 : (side === 'left' ? Math.random() * 0.8 + 0.3 : -(Math.random() * 0.8 + 0.3));
            const baseSpeedY = Math.random() * 1.0 + 0.5;

            // Create train with 7-15 particles
            const trainLength = Math.floor(Math.random() * 9) + 7; // 7-15 particles
            const train = [];

            // Create snake-like path by varying the horizontal movement for each particle
            for (let i = 0; i < trainLength; i++) {
                // Add sine wave variation to create snake-like movement
                const waveAmplitude = Math.random() * 0.3 + 0.2; // Random amplitude for each train
                const waveFrequency = Math.random() * 0.5 + 0.3; // Random frequency for each train
                const phaseShift = Math.random() * Math.PI * 2; // Random phase shift for each train

                // Calculate position with snake-like offset
                const snakeOffset = Math.sin(i * waveFrequency + phaseShift) * waveAmplitude;
                const speedX = baseSpeedX + snakeOffset * 0.1; // Vary horizontal speed slightly

                train.push({
                    id: Math.random() + '-' + i,
                    x: startX - (baseSpeedX * i * 3) + (snakeOffset * i * 0.5), // Apply snake offset to position
                    y: startY - (baseSpeedY * i * 3),
                    size: (Math.random() * 2 + 1) * 1.5, // 1.5x bigger
                    speedX: speedX,
                    speedY: baseSpeedY,
                    opacity: 1 - (i * 0.05), // Gradually fade out
                    trainId: Math.random(), // Group particles by train
                    waveAmplitude: waveAmplitude,
                    waveFrequency: waveFrequency,
                    phaseShift: phaseShift,
                    time: 0 // For animation
                });
            }

            return train;
        };

        // Initialize with more trains
        const initialTrains = [];
        for (let i = 0; i < 5; i++) { // Start with 5 trains
            initialTrains.push(...createTrain());
        }
        setTrains(initialTrains);

        // Add new trains more frequently
        const interval = setInterval(() => {
            setTrains(prev => {
                // Remove particles that have fallen off screen
                const filtered = prev.filter(p => p.y < 105);
                // Add new train
                const newTrain = createTrain();
                return [...filtered, ...newTrain];
            });
        }, 1200); // Add a new train every 1.2 seconds

        // Update particle positions with snake-like movement
        const animationInterval = setInterval(() => {
            setTrains(prev => prev.map(particle => {
                // Update time for wave animation
                const newTime = particle.time + 0.1;

                // Calculate new horizontal position with sine wave
                const snakeOffset = Math.sin(newTime * particle.waveFrequency + particle.phaseShift) * particle.waveAmplitude;
                const newSpeedX = particle.speedX + snakeOffset * 0.05;

                return {
                    ...particle,
                    x: particle.x + newSpeedX,
                    y: particle.y + particle.speedY,
                    speedY: particle.speedY + 0.02, // Gravity effect
                    time: newTime
                };
            }));
        }, 50);

        return () => {
            clearInterval(interval);
            clearInterval(animationInterval);
        };
    }, []);

    return (
        <div className="cummingsoon-container">
            <div className="particles-container">
                {trains.map(particle => (
                    <div
                        key={particle.id}
                        className="particle"
                        style={{
                            left: `${particle.x}%`,
                            top: `${particle.y}%`,
                            width: `${particle.size}px`,
                            height: `${particle.size}px`,
                            opacity: particle.opacity
                        }}
                    />
                ))}
            </div>
            <h1>Cumming soon</h1>
        </div>
    );
};

export default Cummingsoon;